export default __webpack_public_path__ + "static/questglobal-8151f58ccd9942e8c4f733102c7165a0.jpg";